import React from 'react';
import {makeStyles} from '@material-ui/core';
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import {TooltipCustom} from "../common/TooltipCustom";

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: 100,
        textAlign: 'center',
        [theme.breakpoints.only('xs')]: {
            padding: '50px 0px',
        }
    },
    notUnderlined: {
        textDecoration: "none",
    },
    title: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
            lineHeight: '20px',
        }
    },
    subtitle1: {
        fontWeight: 'unset',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            lineHeight: '20px',
        }
    },
    buttonContainer: {
        [theme.breakpoints.only('xs')]: {
            marginTop: 20
        }
    },
    button: {
        color: "#fff",
        backgroundColor: "#94C11F",
        background: "#94C11F 0% 0% no-repeat padding-box",
        width: 220,
        margin: 20,
        marginTop: 50,
        textTransform: 'none',
        fontSize: 19,
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
            lineHeight: '20px',
        },
        [theme.breakpoints.only('xs')]: {
            margin: 0,
            marginTop: 20
        }
    },
    cyberMalveillance: {
        textAlign: 'end',
        padding: 50
    },
    icon: {
        width: 25,
        height: 25,
        marginRight: 10
    }
}));

function Contact() {
    const classes = useStyles();

    return (
        <>
            <div className={classes.root}>
                <Typography component={"h1"} variant={"h1"} className={classes.title} paragraph>
                    Vous souhaitez que votre organisation soit prête,<br/>ou vous en assurer ?
                </Typography>
                <Typography variant={"subtitle1"} component={"subtitle1"} className={classes.subtitle1}>
                    Nos experts en sécurité numérique sont à votre disposition pour répondre à vos questions
                </Typography>
                <div className={classes.buttonContainer}>
                    <a href="tel:04 48 20 15 10" className={classes.notUnderlined}>
                        <TooltipCustom title="04 48 20 15 10" interactive>
                            <Button variant="contained"
                                    className={classes.button}
                                    startIcon={<PhoneIcon className={classes.icon}/>}
                            >
                                Nous appeler
                            </Button>
                        </TooltipCustom>
                    </a>
                    <a href="mailto:soc@cyklad.fr" className={classes.notUnderlined}>
                        <TooltipCustom title="soc@cyklad.fr" interactive>
                            <Button variant="contained"
                                    className={classes.button}
                                    startIcon={<MailIcon className={classes.icon}/>}
                            >
                                Nous écrire
                            </Button>
                        </TooltipCustom>
                    </a>
                </div>
                <div className={classes.cyberMalveillance}>
                    <img src="/image/contact/cyberMalveillance.png" alt="Logo gouvernement cyberMalveillance"/>
                </div>
            </div>
        </>
    )
}

export default Contact